export const NAME = 'shrinkWrappingMachines';